import {getDate} from '@/libs/helper'
import {isEmpty, cloneDeep} from 'lodash'
import {peopleFieldFilter, teamFieldFilter, memberFieldFilter, pendingPeopleFieldFilter, pendingCollabFieldFilter, failedPeopleFieldFilter, pendingMemberFieldFilter, failedMemberFieldFilter} from '@/libs/api/api'
import InfiniteLoading from 'vue-infinite-loading';
import infiniteScroll from 'vue-infinite-scroll'
import {mapGetters} from 'vuex'
import constants from '@/libs/constant/constants'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'OrgFilter',
    components: {InfiniteLoading},
    directives: {infiniteScroll},
    props: {
        type: {
            type: String,
            default: 'name'
        },
        module : {
            type: String,
            default: constants.PEOPLE_LIST.PEOPLE
        },
        setTableFilters: {
            type: Function,
            default: () => {}
        },
        subtype: {
            type: String,
            default: constants.PEOPLE_LIST.MEMBER
        },
        isClear: {
            type: Boolean,
            default: false
        },
        resetClearFields: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters ({
            selectedMetaFilters: 'getOrganisationFilters',
            hasPermission: 'hasPermission'
        })
    },
    watch: {
        selectedMetaFilters (newValue) {
            this.filteredData = cloneDeep(newValue)
        },
        /**
         * to clear fields
         * @param {*} newValue 
         */
        isClear (newValue) {
            if (newValue) this.clearFields()
        }
    },
    data() {
        return {
            getDate,
            filterValue: '',
            showFilter: false,
            filteredData: {},
            metaFilter: [],
            limit: 30,
            skip: 0,
            loadMore: true,
            isFetching: false,
        }
    },
    methods: {
        /**
         * debounce search
         */
        debounceSearch() {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                this.metaFilter = []
                this.skip = 0
                if (this.filterValue && this.filterValue.length > 1) this.fetchFilterData()
            }, 600)
        },

        /**
         * infinite loading handler
         */
        handleInfiniteLoading () {
            if (!this.isFetching && this.loadMore && !isEmpty(this.metaFilter)) this.fetchFilterData(true)
        },

        /**
         * fetch body and params with skip and limit
         */
        fetchParams () {
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            return params
        },

        /**
         * to fetc body for filters
         */
        fetchBody (module) {
            let body = {
                organisation: this.$route.params.id,
                search_text: this.filterValue,
                field_value: this.type
            }
            if (module === constants.PEOPLE_LIST.MEMBER) {
                body.team = this.$route.params.tid
                delete body.organisation
            }
            return body
        },
         /**
         * get the filter data for people on name
         * @param {*} isLoadMore 
         */
        async fetchFilterData (isLoadMore) {
            this.isFetching = true
            // api call
            this.fetchData().then(response => {
                if (isLoadMore) this.metaFilter = this.metaFilter.concat(response.items || [])
                else this.metaFilter = response.items || []
                if (response.item_count < this.limit) {
                    this.loadMore = false
                }
                this.skip += this.limit
                this.isFetching = false
            }).catch(error => {
                console.error(error)
                this.isFetching = false
            })
        },

        /**
         * api call wrapper
         * @param {*} isLoadMore to load more data on infinite loading
         */
        async fetchData () {
            this.isFetching = true
            let body = await this.fetchBody(this.module)
            let params = await this.fetchParams()
            switch (this.type) {
                case 'name': 
                    if (this.module === constants.PEOPLE_LIST.PEOPLE) {
                        switch (this.subtype) {
                            case constants.PEOPLE_LIST.PENDING_INVITATION:
                                return pendingPeopleFieldFilter(body, params)
                            case constants.PEOPLE_LIST.PENDING_COLLABORATORS:
                                return pendingCollabFieldFilter(body, params)
                            case constants.PEOPLE_LIST.MEMBER:
                                return peopleFieldFilter(body, params)
                            case constants.PEOPLE_LIST.FAILED_INVITATION:
                                return failedPeopleFieldFilter(body, params)
                        }
                    }
                    else if (this.module === constants.ORGANISATION.TEAM) {
                        return teamFieldFilter(body, params)
                    }
                    else if (this.module === constants.PEOPLE_LIST.MEMBER) {
                        switch (this.subtype) {
                            case constants.PEOPLE_LIST.PENDING_INVITATION:
                                return pendingMemberFieldFilter(body, params)
                            case constants.PEOPLE_LIST.PENDING_COLLABORATORS:
                                body.organisation = this.$route.params.id
                                return pendingCollabFieldFilter(body, params)
                            case constants.PEOPLE_LIST.MEMBER:
                                if(!this.hasPermission(permissions.memberFieldFilter)) return;
                                return memberFieldFilter(body, params)
                            case constants.PEOPLE_LIST.FAILED_INVITATION:
                                return failedMemberFieldFilter(body, params)
                        }
                    }
                break
            }
        },
        isChecked (name, module) {
            let selectedMetaFilters = cloneDeep(this.selectedMetaFilters)
            if (selectedMetaFilters[module] && selectedMetaFilters[module].filter(item => item === name).length > 0) return true
            return false
        },
        /**
         * add/remove filter
         * @param {*} event 
         * @param {*} value 
         * @param {*} type 
         */
        addOrRemoveItem (event, value, type) {
            this.filteredData[type] = this.selectedMetaFilters[type] ? cloneDeep(this.selectedMetaFilters[type]) : []
            let filteredData = cloneDeep(this.filteredData)
            if (event) {
                filteredData[type].push(value) 
            } else {
                filteredData[type] = filteredData[type].filter(list => list !== value)
            }
            this.filteredData = filteredData
            this.setTableFilters(cloneDeep(this.filteredData))
        },

        /**
         * to clear the fields
         */
        clearFields () {
            this.filterValue = ''
            this.metaFilter = []
            this.resetClearFields()
        }
    }
}